import React, { useEffect, useState } from "react";

import { Plus } from "icons";

import dashboardsApi from "apis/dashboards";
import { Button, PageLoader, Alert, SubHeader } from "clearsense-ui/components";
import NoData from "components/Common/NoData";

import Card from "./Card";
import TitleModal from "./TitleModal";

const Dashboards = () => {
  const [loading, setLoading] = useState(false);
  const [dashboards, setDashboards] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [dashboardDetails, setDashboardDetails] = useState("");

  const fetchDashboards = async () => {
    setLoading(true);
    try {
      const res = await dashboardsApi.fetch();
      setDashboards(res.data.dashboards);
    } catch (error) {
      logger.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDashboards();
  }, []);

  const handleSubmit = async values => {
    setLoading(true);
    try {
      if (dashboardDetails?.id) {
        await dashboardsApi.update(dashboardDetails.id, values);
        setDashboards(prev =>
          prev.map(dashboard =>
            dashboard.id === dashboardDetails.id
              ? { ...dashboard, ...values }
              : dashboard
          )
        );
      } else {
        await dashboardsApi.create(values);
        await fetchDashboards();
      }
      setDashboardDetails("");
      setShowModal(false);
    } catch (error) {
      logger.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async () => {
    setLoading(true);
    try {
      await dashboardsApi.destroy(dashboardDetails.id);
      await fetchDashboards();
    } catch (error) {
      logger.error(error);
    } finally {
      setDashboardDetails("");
      setShowAlert(false);
      setLoading(false);
    }
  };

  const updateFavorite = async (id, favorite) => {
    try {
      await dashboardsApi.update(id, { favorite });
      setDashboards(prev =>
        prev.map(dashboard =>
          dashboard.id === id ? { ...dashboard, favorite } : dashboard
        )
      );
    } catch (err) {
      logger.error(err);
    }
  };

  if (loading) return <PageLoader />;

  return (
    <div className="p-4 cs-ui-container">
      <SubHeader
        breadcrumbs={[{ label: "Dashboards", link: "#" }]}
        className="p-4"
        actionBlock={
          <Button
            icon={Plus}
            data-cy="add-new-dashboard-button"
            label="Create Dashboard"
            onClick={() => {
              setDashboardDetails("");
              setShowModal(true);
            }}
          />
        }
      />

      {!dashboards.length ? (
        <NoData
          entity="dashboards"
          actionLabel="Create Dashboard"
          onAction={() => {
            setDashboardDetails("");
            setShowModal(true);
          }}
        />
      ) : (
        <div className="grid gap-4 m-4 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
          {dashboards.map(dashboard => (
            <Card
              key={dashboard.id}
              dashboard={dashboard}
              setDashboardDetails={setDashboardDetails}
              setShowModal={setShowModal}
              setShowAlert={setShowAlert}
              updateFavorite={updateFavorite}
            />
          ))}
        </div>
      )}
      <TitleModal
        dashboardDetails={dashboardDetails}
        showModal={showModal}
        setShowModal={setShowModal}
        setDashboardDetails={setDashboardDetails}
        handleSubmit={handleSubmit}
      />
      <Alert
        isOpen={showAlert}
        title="Delete Dashboard"
        message="Are you sure you want to delete the dashboard along with all it's charts?"
        closeButton={false}
        onClose={() => {
          setDashboardDetails("");
          setShowAlert(false);
        }}
        onSubmit={handleDelete}
      />
    </div>
  );
};

export default Dashboards;
